import { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, track } from "@/lib/api";

export default function Gallery() {
  const { data: items = [] } = useQuery({ queryKey: ["gallery"], queryFn: () => api.get("/gallery", { params: { is_active: true, limit: 200 } }).then((r) => r.data.items) });
  const [cat, setCat] = useState("all");
  const [lightbox, setLightbox] = useState(null);
  useEffect(() => { track("gallery_view"); }, []);

  const categories = useMemo(() => Array.from(new Set(items.map((i) => i.category).filter(Boolean))), [items]);
  const list = cat === "all" ? items : items.filter((i) => i.category === cat);

  return (
    <div className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-xs uppercase tracking-[0.24em] text-amber-600 mb-4">Gallery</div>
        <h1 className="font-display text-5xl sm:text-6xl text-slate-950 leading-none">A visual journal.</h1>
        <div className="mt-10 flex flex-wrap gap-2">
          <button onClick={() => setCat("all")} className={`px-4 py-2 rounded-full text-sm border ${cat === "all" ? "bg-slate-950 text-white border-slate-950" : "border-slate-300 text-slate-700"}`} data-testid="gallery-cat-all">All</button>
          {categories.map((c) => (
            <button key={c} onClick={() => setCat(c)} className={`px-4 py-2 rounded-full text-sm border ${cat === c ? "bg-slate-950 text-white border-slate-950" : "border-slate-300 text-slate-700"}`} data-testid={`gallery-cat-${c}`}>{c}</button>
          ))}
        </div>
        <div className="mt-10 masonry" data-testid="gallery-masonry">
          {list.map((g) => (
            <button key={g.id} onClick={() => setLightbox(g)} className="w-full rounded-xl overflow-hidden block" data-testid={`gallery-item-${g.id}`}>
              <img src={g.image_url} alt={g.title} className="w-full hover:scale-105 transition-transform duration-500" loading="lazy" />
            </button>
          ))}
        </div>
      </div>
      {lightbox && (
        <div className="fixed inset-0 z-50 bg-black/90 grid place-items-center p-6" onClick={() => setLightbox(null)}>
          <div className="max-w-5xl w-full">
            <img src={lightbox.image_url} className="w-full max-h-[80vh] object-contain rounded-lg" alt={lightbox.title} />
            <div className="text-white/80 text-sm mt-3 text-center">{lightbox.title}</div>
          </div>
        </div>
      )}
    </div>
  );
}
